<template>
    <div class="floating-service-container" ref="floatingServiceContainer">
        <!-- 充值按钮从上方滑出 -->
        <!-- <div class="service-button recharge" :class="{ 'show': showButtons }" @click="recharge()">
            <i class="iconfont icon-recharge"></i>
            <span>充值</span>
        </div> -->
        
        <!-- 主按钮 -->
        <div class="floating-service" @click="recharge()">
            <i class="iconfont icon-kefu"></i>
        </div>
        <div class="floating-service" @click="complaint()">
            <i class="iconfont icon-warning"></i>
        </div>
        
        <!-- 投诉按钮从下方滑出 -->
        <!-- <div class="service-button complaint" :class="{ 'show': showButtons }" @click="complaint()">
            <i class="iconfont icon-warning"></i>
            <span>投诉</span>
        </div> -->
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { showToast } from 'vant'
import common from '@/uilts/common'

const router = useRouter()
const webInfo = ref({})
const showButtons = ref(false)
const floatingServiceContainer = ref(null)

onMounted(() => {
    // 获取当前站点
    common.getWeb().then(res => {
        if (res) {
            webInfo.value = res
        }
    })
    
    // 添加全局点击事件监听器，点击其他地方时收起按钮
    document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
    // 移除全局点击事件监听器
    document.removeEventListener('click', handleClickOutside)
})

// 切换按钮显示
const toggleButtons = () => {
    showButtons.value = !showButtons.value
}

// 投诉
const complaint = () => {
    router.push({ path: '/complaint', query: { position: 1 } })
    showButtons.value = false
}

// 客服
const recharge = () => {
    showButtons.value = false
    if (webInfo.value.web_service_config == 1) {
        // 自有客服
        common.openKf()
        // 七鱼客服
    } else if (webInfo.value.web_service_config == 2) {
        common.service()
    } else {
        showToast('暂无获取到客服配置')
    }
}

// 处理点击其他地方时收起按钮
const handleClickOutside = (event) => {
    if (floatingServiceContainer.value && !floatingServiceContainer.value.contains(event.target) && showButtons.value) {
        showButtons.value = false
    }
}
</script>

<style scoped lang="scss">
.service-buttons {
    display: flex;
    align-items: center;
    margin-right: 0;
    width: 0;
    overflow: hidden;
    transition: all 0.3s ease;

    &.show {
        width: 100px;
    }

    .buttons-container {
        display: flex;
        align-items: center;
        background-color: var(--color2);
        border-radius: 20px 0 0 20px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        // padding: 5px 0 5px 10px;
        padding: 0px 20px 0px 0;
        .service-button {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            border-radius: 50%;
     
            &:last-child {
                margin-right: 0;
            }


            span {
                font-size: 16px;
                font-weight: bold;
                color: var(--color3);
            }
        }
    }
}
/* 悬浮客服 */
.floating-service-container {
    position: fixed;
    bottom: 150px;
    right: 10px;
    z-index: 999;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.service-button {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: var(--color2);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    opacity: 0;
    position: absolute;
    transform: scale(0.8);
    overflow: hidden;
    pointer-events: none;
    
    &.recharge {
        transform: translateY(0) scale(0.8);
        bottom: 20px;
    }
    
    &.complaint {
        transform: translateY(0) scale(0.8);
        top: 20px;
    }
    
    &.show {
        opacity: 1;
        transform: scale(1);
        pointer-events: auto;
    }
    
    &.show.recharge {
        transform: translateY(-25px) scale(1);
    }
    
    &.show.complaint {
        transform: translateY(25px) scale(1);
    }

    .iconfont {
        font-size: 20px;
        color: var(--color3);
        margin-bottom: 2px;
    }

    span {
        font-size: 10px;
        font-weight: bold;
        color: var(--color3);
    }
}

.floating-service {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: var(--color2);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);

    &:last-child {
        margin-top: 10px;
    }

    .iconfont {
        font-size: 28px;
        color: var(--color3);
    }
}
</style>